import { ModelCategory } from '@paragon/contract-library';

import { GenericModelSchema } from '../ModelSchema';
import { DistanceProperty } from '../properties';
import { EnumProperty } from '../properties/EnumProperty';

export const LumberSchema = new GenericModelSchema('lumber', {
  category: ModelCategory.ComponentDesignData,

  properties: {
    grade: EnumProperty,
    species: EnumProperty,
    treatmentType: EnumProperty,
    nominalWidth: DistanceProperty,
    nominalThickness: DistanceProperty,
    length: DistanceProperty,
  },
});
